import { URL_CONFIG } from "./urlConfig";

export const ATP_API_URL = {
    LOGIN: `${URL_CONFIG.ATP_API_BASE_URL}api/Auth/login`,
    REQUEST_OTP: `${URL_CONFIG.ATP_API_BASE_URL}api/Auth/login`,
    VERIFY_OTP: `${URL_CONFIG.ATP_API_BASE_URL}api/Auth/verify-otp`,
    SEND_ALL_DATA: `${URL_CONFIG.ATP_API_BASE_URL}api/entity/create-onboarding`,
    UPDATE_ALL_DATA: `${URL_CONFIG.ATP_API_BASE_URL}api/entity/update-onboarding`,
    GET_ALL_DATA: `${URL_CONFIG.ATP_API_BASE_URL}api/entity/onboardingList`,
    // TODO: searching the data and all listing data here with paginations 
    GET_ALL_DATA_SEARCH: `${URL_CONFIG.ATP_API_BASE_URL}api/entity/search-onboarding`,

    TOTAL_COUNTS: `${URL_CONFIG.ATP_API_BASE_URL}api/entity/total-counts`,
    REQUIRED_DOCUMENTS: `${URL_CONFIG.ATP_API_BASE_URL}api/entity/required-documents`,
    UPLOAD_DOCUMENT: `${URL_CONFIG.ATP_API_BASE_URL}api/entity/upload-document`,
    DEPARTMENT_LIST: `${URL_CONFIG.ATP_API_BASE_URL}api/entity/department-list`,
};
